import axios, { AxiosError } from 'axios';

export const getSwrFetcher = async (url: string) => {
  const options = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await axios.get(url, options);

    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(`API Error: ${error.response?.data?.message || error.message}`);
    }

    throw error;
  }
};
